export default {
	cixiangweibitianxiang: '此項為必填項',
	dengluyihuode: '登入以獲得更無縫的流程。',
	haimeiyouzhanghu: '還沒有帳號？',
	lijizhuce: '立即注册',
	xuanzebeishiwei: '選擇該選項後，您將被視為已同意',
	tiaokuan: '條款和條件',
	yinsishengming: '隱私權聲明',
	yiji: '以及',
	huo: '或',
	dianziyoujian: '電子郵件',
	mima: '密碼',
	dengru: '登錄',
	qudenglu: '去登錄',
	zhuce: '注册',
	zhucechenggong: '注册成功',
	buyizhi: '不一致',
	meiyoushoudao: '沒有收到你的電子郵件驗證？',
	yikerenshenfen: '以客人身份繼續',
	wangjimima: '忘記密碼',
	zhanghao: '账号',
	yanzhengzhanghao: '验证账号',
	yanzhengmima: '验证密码',
	youketishi: '繼續作為客人，即表示您同意本網站的條款、數據政策和Cookie政策。',
	chakan: '查看',
	xuanzeriqi: '選擇日期',
	chufariqi: '出發日期',
	huichengriqi: '回程日期',
	chongshe: '重設',
	queren: '確認',
	genggairiqi: '更改日期',
	hangban: '航班',
	yingfuzonge: '應付總額',
	genggai: '更改',
	xianyoufujai: '現有附加服務',
	xinhangban: '新航班',
	zhifu: '支付',
	daojishi: '支付倒計時',
	zuoweiyiyuding: '抱歉，這個座位已被預訂，請選擇其他座位。',
	tianjiadaoyuding: '添加到預訂',
	ewaituibukongjian: '額外腿部空間，第10行，C座位',
	xinyongka: '信用卡',
	denglushiyongfacebook: '使用FaceBook登錄',
	jiazaizhong: '加載中',
	denglushibai: '登录失败!',
	zhuceshibai: '注册失败!',
	liru: '例如',
	dengluchenggong: '登錄成功',
};
